import type { Module } from '../types/module';

export const modules: Module[] = [
  { id: "1", status: 'locked', title: 'Medical Terminology & Anatomy', progress: 0 },
  { id: "2", status: 'locked', title: 'CPT & HCPCS Fundamentals' },
  { id: "3", status: 'locked', title: 'ICD-10-CM Guidelines & Structure' },
  { id: "4", status: 'locked', title: 'CPT & HCPCS Coding' },
  { id: "HL1", status: 'locked', title: 'Hackathon Level-1' },
  { id: "HL2", status: 'locked', title: 'Hackathon Level-2' },
];